document.addEventListener('click', (e) => {
  const triggerBtn = e.target.closest('[data-modal-src]');
  if (triggerBtn) {
    const modal = document.getElementById('ss-modal-guia');
    const img = document.getElementById('ss-modal-img');
    if (!modal || !img) return;
    img.src = triggerBtn.dataset.modalSrc;
    modal.classList.remove('ss-modal-hidden');
    document.body.style.overflow = 'hidden';
    return;
  }

  const modal = document.getElementById('ss-modal-guia');
  if (!modal || modal.classList.contains('ss-modal-hidden')) return;

  if (e.target === modal || e.target.closest('#ss-modal-close-btn')) {
    modal.classList.add('ss-modal-hidden');
    document.body.style.overflow = '';
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const modal = document.getElementById('ss-modal-guia');
  if (modal && !modal.classList.contains('ss-modal-hidden')) {
    modal.classList.add('ss-modal-hidden');
    document.body.style.overflow = '';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.badge-responsive').forEach(function (badge) {
    badge.style.setProperty('--badge-desktop-width',  badge.dataset.desktopWidth  + 'px');
    badge.style.setProperty('--badge-desktop-height', badge.dataset.desktopHeight + 'px');
    badge.style.setProperty('--badge-mobile-width',   badge.dataset.mobileWidth   + 'px');
    badge.style.setProperty('--badge-mobile-height',  badge.dataset.mobileHeight  + 'px');
  });
});
